import React from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo">
            <span className="logo-text">VERALON</span>
          </div>
          <div className="nav-links">
            <Link to="/login" className="nav-link">Login</Link>
            <Link to="/signup" className="btn-primary">Get Started</Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <h1 className="hero-title">
            Financial Intelligence for<br />
            Law Enforcement & Government
          </h1>
          <p className="hero-subtitle">
            Automated bank statement analysis. Detect fraud, structuring, and money laundering patterns in seconds.
          </p>
          <div className="hero-buttons">
            <Link to="/signup" className="btn-hero-primary">Start Free Trial</Link>
            <a href="#features" className="btn-hero-secondary">Learn More</a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="features-container">
          <h2 className="section-title">Powerful Analysis Tools</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>28 Analytical Modules</h3>
              <p>From basic transaction tracking to advanced money laundering detection</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🤖</div>
              <h3>AI-Powered Parsing</h3>
              <p>Works with any bank statement from any institution worldwide</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Instant Reports</h3>
              <p>Upload a PDF, get back Excel intelligence reports in seconds</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Enterprise Security</h3>
              <p>End-to-end encryption, SOC 2 compliant infrastructure</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Fraud Detection</h3>
              <p>Automatic flagging of structuring, lifestyle mismatches, and anomalies</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Pattern Recognition</h3>
              <p>Machine learning identifies suspicious transaction patterns</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <div className="pricing-container">
          <h2 className="section-title">Simple, Transparent Pricing</h2>
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Basic</h3>
              <div className="price">$99<span>/month</span></div>
              <ul className="features-list">
                <li>50 analyses per month</li>
                <li>All analytical modules</li>
                <li>Email support</li>
                <li>Excel report export</li>
              </ul>
              <Link to="/signup" className="btn-pricing">Get Started</Link>
            </div>
            <div className="pricing-card featured">
              <div className="badge">Most Popular</div>
              <h3>Professional</h3>
              <div className="price">$299<span>/month</span></div>
              <ul className="features-list">
                <li>500 analyses per month</li>
                <li>All analytical modules</li>
                <li>Priority support</li>
                <li>API access</li>
                <li>Custom integrations</li>
              </ul>
              <Link to="/signup" className="btn-pricing">Get Started</Link>
            </div>
            <div className="pricing-card">
              <h3>Enterprise</h3>
              <div className="price">$799<span>/month</span></div>
              <ul className="features-list">
                <li>Unlimited analyses</li>
                <li>All analytical modules</li>
                <li>24/7 phone support</li>
                <li>White-label option</li>
                <li>Dedicated success manager</li>
              </ul>
              <Link to="/signup" className="btn-pricing">Get Started</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <p>&copy; 2026 Veralon. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
